import React from 'react';

import SectionCTA from '../../section-cta';
import { getFluidGatsbyImage } from '../../../utils/gatsby-storyblok-image-fixed/';
import parseStoryblokLink from '../../../utils/parse-storyblok-link';

interface StoryblokCtaBannerProps {
  backgroundImage: any;
  mobileBackgroundImage: any;
  ctaLink?: any;
  links?: Array<{
    link: any;
    children: string;
  }>;
  secondLink?: any;
  secondLinkTitle?: string;
  [key: string]: any;
}

function StoryblokCtaBanner(props: StoryblokCtaBannerProps) {
  const { backgroundImage, mobileBackgroundImage, ...rest } = props;

  const fluidImageDesktop = getFluidGatsbyImage(backgroundImage, {
    maxWidth: 2560
  });
  const fluidImageMobile = getFluidGatsbyImage(mobileBackgroundImage, {
    maxWidth: 700
  });

  const links = getLinks(props);

  return (
    <SectionCTA
      {...rest}
      {...links}
      gatsbyImg
      desktopBackground={fluidImageDesktop}
      mobileBackground={fluidImageMobile}
    />
  );
}

const getLinks = (props: StoryblokCtaBannerProps) => {
  if (props.links) {
    const [linkOne, linkTwo] = props.links;

    return {
      ctaLink: parseStoryblokLink(linkOne.link),
      ctaText: linkOne.children,
      secondLink: linkTwo && {
        to: parseStoryblokLink(linkTwo.link),
        title: linkTwo.children
      }
    };
  }

  return {
    ctaLink: parseStoryblokLink(props.ctaLink),
    secondLink: props.secondLink &&
      props.secondLinkTitle && {
        to: parseStoryblokLink(props.secondLink),
        title: props.secondLinkTitle
      }
  };
};

export default StoryblokCtaBanner;
